import Vue from 'vue';
import Router from 'vue-router';
import PatientDetails from '../views/PatientDetails.vue';
import Timeout from '../views/Timeout.vue';
import EndPoint from '../views/EndPoint.vue';
import Consent from '../views/Consent.vue';
import PreQuestionnaire from '../views/PreQuestionnaire.vue';
import EpilepsyQuestionnaire from '../views/EpilepsyQuestionnaire.vue';
import SectionOfEpilepsyQuestions from '../views/SectionOfEpilepsyQuestions.vue';
import Completed from '../views/Completed.vue';
import CompletedParent from '../views/CompletedParent.vue';
import SectionOfQuestions from '../views/SectionOfQuestions.vue';
import SectionOfQuestions8to10 from '../views/SectionOfQuestions8to10.vue';
import SectionOfQuestionsImpact from '../views/SectionOfQuestionsImpact.vue';
import SectionOfQuestionsFurtherInfo from '../views/SectionOfQuestionsFurtherInfo.vue';
import Summary from '../views/Summary.vue';
import Result from '../views/Result.vue';
import json from '../../public/api/data.json';

const createRoutes = function () {
  let routeData = json.questions
    .map((
      { 
        id, 
        questionType
      }) => (
      { 
        path: `/${id}`, 
        name: id.toLowerCase(), 
        component: getComponent(questionType)
      }
    )
  );
  routeData.unshift({ path: '/', redirect: '/PatientDetails' });
  routeData.push({ path: '/Result', name: 'result', componenet: getComponent("") });
  routeData.push({ path: '/Timeout', name: 'timeout', component: Timeout })
  return routeData;
};

const getComponent = function (questionType) {
  switch (questionType) {
    
    case "Consent":
      return Consent;
    case "PatientDetails":
      return PatientDetails;
    case "PreQuestionnaire":
      return PreQuestionnaire;
    case "EpilepsyQuestionnaire":
      return EpilepsyQuestionnaire;
    case "SectionOfEpilepsyQuestions":
      return SectionOfEpilepsyQuestions;
    case "SectionOfQuestions":
      return SectionOfQuestions;
    case "SectionOfQuestionsImpact":
      return SectionOfQuestionsImpact;
    case "SectionOfQuestionsFurtherInfo":
      return SectionOfQuestionsFurtherInfo;
    case "SectionOfQuestions8to10":
      return SectionOfQuestions8to10;
    case "Endpoint":
      return EndPoint;
      case "Completed":
        return Completed;
    case "CompletedParent":
      return CompletedParent;
    case "Summary":
      return Summary;
    default:
      return Result;
  }
};

Vue.use(Router)

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: createRoutes(),
    scrollBehavior() {
      window.scrollTo(0,0);
    }
});

router.beforeEach((to, from, next) => {
  if (to.path === '/PatientDetails' && from.path === '/PreQuestionnaire11to17' && from.path === '/PreQuestionnaire5To10' && from.path === '/PreQuestionnaire11To17withHelp') {
  console.log('continue');
  }else{
    localStorage.clear();
  } 
  next();
});

export default router;